import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
export const useElementSize = ref => {
  const _useState = useState(null),
        _useState2 = _slicedToArray(_useState, 2),
        size = _useState2[0],
        saveSize = _useState2[1];

  useEffect(() => {
    if (!size && ref.current) {
      const rect = ref.current.getBoundingClientRect();

      if (rect.width && rect.height) {
        saveSize(rect);
      }
    }
  }, [size, ref]);
  return size;
};